// jQuery(document).on('click', '#store_id_3249563 .item-content .linkdetailstore', function(e) {
//             e.preventDefault();
//    $("#store_id_3249563 .item-content .linkdetailstore").removeAttr("href");
//   location.assign("https://forwardfurniture.ca/pages/kelowna-store-location");
// });

// jQuery(document).on('click', '#store_id_3249569 .item-content .linkdetailstore', function(e) {
//             e.preventDefault();
//   $("#store_id_3249569 .item-content .linkdetailstore").removeAttr("href");
// window.location.href ="https://forwardfurniture.ca/pages/calgarys-store-location";
// });


// jQuery(document).on('click', '#store_id_3249570 .item-content .linkdetailstore', function(e) {
//             e.preventDefault();
//   $("#store_id_3249570 .item-content .linkdetailstore").removeAttr("href");
//  window.location.href = "https://forwardfurniture.ca/pages/edmontons-store-location";
// });

document.addEventListener('click', function(e) {
  if (e.target.classList.contains('linkdetailstore')) {
    e.preventDefault();
    var gethref = e.target.getAttribute('href');
    e.target.removeAttribute("href");
    
    if (gethref === "//forwardfurniture.ca/a/store-locator/forward-furniture-calgary.html" ||
        gethref === "/a/store-locator/forward-furniture-calgary.html") {
      window.location.href = "https://forwardfurniture.ca/pages/calgarys-store-location";
    }
    
    if (gethref === "//forwardfurniture.ca/a/store-locator/forward-furniture-kelowna.html" ||
        gethref === "/a/store-locator/forward-furniture-kelowna.html") {
      window.location.href = "https://forwardfurniture.ca/pages/kelowna-store-location";
    }
    
    if (gethref === "//forwardfurniture.ca/a/store-locator/forward-furniture-edmonton.html" ||
        gethref === "/a/store-locator/forward-furniture-edmonton.html") {
      window.location.href = "https://forwardfurniture.ca/pages/edmontons-store-location";
    }
  }
});